import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from 'src/assets/Configuration';

@Injectable({
  providedIn: 'root'
})
export class BrokerAccessService {

  constructor(private httpClient: HttpClient) {}

  public canSendBrokerAccess(personId: string): Observable<boolean> {
    return this.httpClient.get<boolean>(
      Configuration.getApiBaseUrl() + `/broker-access/${personId}/can-send`
    );
  }
}